// React imports
import React from 'react';

// gatsby imports
import { PageProps, graphql } from 'gatsby';

// SEO
import SEO from 'components/seo';

// Theme and layout
import WithTheme from 'components/WithTheme';
import Layout from 'views/Layout';
import Glosario from 'views/EducacionFinanciera/Glosario';

type DataProps = {
    site: {
        buildTime: string;
    };
};

const EducationPage: React.FC<PageProps<DataProps>> = ({ data, path, location }) => (
    <WithTheme>
        <Layout location={location}>
            <SEO title="Glosario — Educación Financiera" />

            <Glosario />
        </Layout>
    </WithTheme>
);

export default EducationPage;

export const query = graphql`
    {
        site {
            buildTime(formatString: "YYYY-MM-DD hh:mm a z")
        }
    }
`;
